// @ts-nocheck
/* eslint-disable */
export const niNavLeftMobileIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 12"><g fill="none" fill-rule="evenodd"><path fill="#FFF" d="M0 0H375V694H0z" transform="translate(-252 -670)"/><path d="M0 5L5 0 5.7 0.7 1.4 5 5.7 9.3 5 10z" transform="translate(-252 -670) translate(252 670) translate(1 1)" fill="#044123"/></g></svg>`,
    name: 'nav-left-mobile' as const
};